import { MCP_URL } from '../guideContent'

/** Открывает в claude.ai окно «Add custom connector» с уже заполненными
 *  названием и адресом сервера — автору остаётся нажать «Add». */
export const claudeConnectUrl = (): string => {
  const params = new URLSearchParams({
    modal: 'add-custom-connector',
    connectorName: 'OA Studio',
    connectorUrl: MCP_URL,
  })
  return `https://claude.ai/customize/connectors?${params.toString()}`
}

export const CLAUDE_HOME_URL = 'https://claude.ai'
export const CLAUDE_NEW_CHAT_URL = 'https://claude.ai/new'
